<template>
  <v-card
    id="encours"
    fluid
  >
  <v-card-title class="blue darken-3">
          <span class="text-h5 white--text">Calendrier</span>

  </v-card-title>
  

<template>
  <v-data-table
    :headers="headers"
    :items="datas"
    :items-per-page="all"
    class="elevation-1"
  ></v-data-table>
</template>

</v-card>
</template>
<script>
  
  export default {

    data: () =>({


      datas :[],
      headers: [
          {
            text: 'Date',
            align: 'start',
            sortable: true,
            value: 'start',
          },
          { text: 'End', value: 'end' },
          { text: 'note', value: 'name' },
          { text: 'Color', value: 'color' }

        ],
      N_Dernieres : 1,
      Unite:"Minutes",
      Unites:['Semaines','Jours','Heures','Minutes'],
      modes: ['Dernières données', 'Interval de dates','Depuis une date'],
      mode_choisi : 'Dernières données',

      start_time : null,
      start_date :null,

      je_cherche : false,

      end_time : null,
      end_date :null,
      url :"",
      data:{},

    }),
  initialize(){

  },
  created(){
    
  },
  beforeMount(){
     

  },
  mounted(){

    this.get_Dates();
  //  this.load_Target();
/*    this.A_Update_target = setInterval(() => {
      this.get_Target();
      this.load_Target();
    },2000);*/
  },
  methods: {
    get_Dates(){
      

      const othis=this;

        othis.url = "";
        othis.url = backend_url + "/journalisationbeta/calendarOLD";
        othis.data = {};
        console.log(othis.url);
        this.axios.get(othis.url,othis.data)
        .then((res) => {
          console.log(res);
          othis.datas = res.data;

        })
        .catch((error) => {
          console.error(error);
          console.log("PB get -> Get_Journalisation_Dates");
        });

    }

  }
}
</script>